import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgMedicalStar = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M20.5833 8.395L19.3558 6.22833C19.277 6.08691 19.1708 5.96264 19.0434 5.86282C18.9159 5.76299 18.7699 5.68962 18.6137 5.64701C18.4575 5.60439 18.2944 5.59339 18.1339 5.61466C17.9734 5.63592 17.8188 5.68902 17.6791 5.77083L14.5 7.66667V3.875C14.5029 3.54649 14.3752 3.23028 14.145 2.99588C13.9148 2.76148 13.601 2.62808 13.2725 2.625H10.7275C10.399 2.62808 10.0851 2.76148 9.85495 2.99588C9.62477 3.23028 9.49709 3.54649 9.49998 3.875V7.66667L6.31831 5.7725C6.17863 5.69068 6.02401 5.63759 5.86353 5.61632C5.70305 5.59506 5.53995 5.60606 5.38377 5.64867C5.2276 5.69129 5.08151 5.76466 4.95408 5.86448C4.82664 5.96431 4.72042 6.08858 4.64165 6.23L3.41665 8.395C3.25329 8.6818 3.20882 9.0212 3.29279 9.34041C3.37676 9.65961 3.58247 9.9332 3.86581 10.1025L7.09081 12L3.86415 13.8975C3.58109 14.0671 3.37573 14.3408 3.29208 14.66C3.20842 14.9791 3.25314 15.3184 3.41665 15.605L4.64331 17.7717C4.72208 17.9131 4.8283 18.0374 4.95574 18.1372C5.08318 18.237 5.22927 18.3104 5.38544 18.353C5.54161 18.3956 5.70472 18.4066 5.8652 18.3853C6.02568 18.3641 6.1803 18.311 6.31998 18.2292L9.49998 16.3333V20.125C9.50216 20.4558 9.63456 20.7725 9.86851 21.0065C10.1025 21.2404 10.4191 21.3728 10.75 21.375H13.25C13.5808 21.3728 13.8975 21.2404 14.1315 21.0065C14.3654 20.7725 14.4978 20.4558 14.5 20.125V16.3333L17.6816 18.2308C17.8213 18.3126 17.9759 18.3657 18.1364 18.387C18.2969 18.4083 18.46 18.3973 18.6162 18.3547C18.7724 18.312 18.9184 18.2387 19.0459 18.1389C19.1733 18.039 19.2795 17.9148 19.3583 17.7733L20.5858 15.6067C20.7492 15.3199 20.7936 14.9805 20.7097 14.6613C20.6257 14.3421 20.42 14.0685 20.1366 13.8992L16.91 12L20.1366 10.1025C20.4196 9.93279 20.6248 9.65902 20.7082 9.33985C20.7917 9.02068 20.7469 8.6815 20.5833 8.395V8.395Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgMedicalStar.displayName = 'SvgMedicalStar';
export default SvgMedicalStar;
